import styled from 'styled-components';

export const RootContainer = styled.div`
    position: relative;
`;
